export default __webpack_public_path__ + "static/media/Gawain2.8059edee.png";